import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useQuery() {
  const location = useLocation();
  const search = location.search;
  return useMemo(() => new URLSearchParams(search), [search])
}
